const TrialResultsContent = () => {
    return (
        <>
            <h4>
                ANZ 9602 ATLAS clinical trial
            </h4>
            <p>
                Results from an analysis of the ANZ 9602 ATLAS (Adjuvant Tamoxifen Longer Against Shorter) clinical trial are published in The Lancet and showed that the use of tamoxifen for ten, rather than 5 years results in a significant reduction in breast cancer recurrence, and hence a reduction in death due to breast cancer and a reduction in overall mortality. Breast Cancer Trials recruited 784 women to this clinical trial.
            </p>
        </>
    );
}

export default TrialResultsContent;